<div class="wrapper">
  <mat-checkbox
    [(ngModel)]="value"
    [required]="required"
    [disabled]="!isEdit || !isEditable"
    (change)="handleValueChange(value)"
  >
  </mat-checkbox>
</div>

